module.exports = __webpack_public_path__ + "93c28fb408831532b2ddc8a02f45ac23.pdf";